import type { Action } from './types'
import type { ListState } from '../premium/types'
import type { Dispatch } from 'react'

import { useReducer } from 'react'

const initialState: ListState = {
  expandedRow: {
    id: undefined
  },

  searchParams: {
    query: '',
    locationIds: [],
    fundingTypes: [],
    pushTypes: [],
    networks: [],
    openAr: [],
    currentAr: [],
    schedule: [],
    isActive: [],
    flags: [],
    nextPullDate: []
  },

  pagination: {
    pageSize: 10,
    currentPage: 0
  },

  sort: {
    field: undefined,
    order: undefined
  }
}

function reducer(state: ListState, action: Action): ListState {
  switch (action.type) {
    case 'set-query': {
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          query: action.payload
        }
      }
    }

    case 'set-expanded-row-id': {
      return {
        ...state,
        expandedRow: {
          ...state.expandedRow,
          id: action.payload
        }
      }
    }

    case 'clear-expanded-row-id': {
      return {
        ...state,
        expandedRow: {
          ...state.expandedRow,
          id: undefined
        }
      }
    }

    case 'set-pagination': {
      return {
        ...state,
        pagination: action.payload
      }
    }

    case 'set-sort': {
      return {
        ...state,
        sort: action.payload,
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    case 'set-refresh-interval': {
      return {
        ...state,
        refreshInterval: action.payload
      }
    }

    case 'clear-refresh-interval': {
      return {
        ...state,
        refreshInterval: undefined
      }
    }

    case 'clear-filters': {
      return {
        ...state,
        searchParams: initialState.searchParams,
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    case 'set-filters': {
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.payload
        },
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    default: {
      return state
    }
  }
}

export const useStore = (): [ListState, Dispatch<Action>] => {
  const [state, dispatch] = useReducer(reducer, initialState, state => {
    return state
  })

  return [state, dispatch]
}
